export const RETRY_DIRECTIVE = 'toastRetry'
